import { configureStore } from "@reduxjs/toolkit";
import branchlistSlice from "./branchlistSlice";
import dashboardSlice from "./dashboardSlice";
import otherSlice from "./otherSlice";
import tempSlice from "./tempSlice";
import coneSlice from "./coneSlice";
import gasflowSlice from "./gasflowSlice";
import generateSlice from "./generateSlice";

const store = configureStore({
  reducer: {
    branch_list: branchlistSlice,
    dashboard: dashboardSlice,
    other: otherSlice,
    temp: tempSlice,
    cones: coneSlice,
    gasflow: gasflowSlice,
    generate: generateSlice,
  },
});
export default store;
